import React from 'react';
import { graphql } from 'gatsby';
import Layout from '../../components/shared/layout';
import SEO from '../../components/SEO/SEOPage';
import styled from '@emotion/styled';
import {
  wrapper,
  breakpoints,
  ContentStyles,
  ContentStylesExt, color
} from "../../utils/style"
import Breadcrumbs from '../../components/shared/Breadcrumbs';
import Parallax from '../../components/shared/Parallax';
import Demo10Games from "../../components/Content/Home/SlotGamesNoQuery"

const WrapperDesktop = styled('div')`
  ${wrapper}
  .decorative-line {
    width: 288px;
    height: 2px;
    background: ${color.pink};
    margin: 20px 0;
  }
  @media (max-width: ${breakpoints.sm}) {
    .decorative-line {
      width: 100%;
      margin: 16px 0;
    }
  }
`;

const ContentWrapper = styled('div')`
  ${wrapper}
  ${ContentStyles}
  ${ContentStylesExt}
  padding: 0;
  margin-bottom: 40px;
  iframe {
    min-height: 600px;
  }
  .button-group {
    margin-top: 20px;
    .pink-button {
      margin-right: 24px;
    }
  }
  @media (max-width: ${breakpoints.md}) {
    iframe {
      min-height: 400px;
    }
  }
  @media (max-width: ${breakpoints.sm}) {
    iframe {
      min-height: 215px;
    }
    .button-group {
      margin-top: 16px;
    }
  }
`;


const PageTemplate = ({ data, pageContext }) => {
  const currentPage = data.wordpressPage;
  const breadcrumbs = pageContext.breadcrumbs;
  const page_title = pageContext.page_title;
  const metaTitle = (currentPage.yoast_meta && currentPage.yoast_meta.yoast_wpseo_title)
    ? currentPage.yoast_meta.yoast_wpseo_title : currentPage.title + "- " + process.env.OWNER;
  const metaDesc = (currentPage.yoast_meta && currentPage.yoast_meta.yoast_wpseo_metadesc)
    ? currentPage.yoast_meta.yoast_wpseo_metadesc : '';
  const homePageNode = data.allWordpressPage.edges[0].node
  const showDemoGames = homePageNode.acf.demo_games_10.length > 0
  const demoGames = homePageNode.acf.demo_games_10
  const socialImage = currentPage.featured_media?.localFile?.publicURL

  return (
    <Layout>
      <SEO
        title={metaTitle}
        description={metaDesc}
        pathname={currentPage.path}
        breadcrumbs={breadcrumbs}
        socialImage={socialImage}
      />
      <Parallax />
      <WrapperDesktop>
        <Breadcrumbs breadcrumbs={breadcrumbs} page_title={page_title}/>

        {showDemoGames && <Demo10Games slotSlides={demoGames} />}

        <ContentWrapper>
          <div dangerouslySetInnerHTML={{ __html: currentPage.content }}/>
        </ContentWrapper>
      </WrapperDesktop>
    </Layout>
  );
};

export default PageTemplate;

export const pageQuery = graphql`
  query($id: String!) {
    allWordpressPage(filter: { slug: { eq: "home-page" } }) {
      edges {
        node {
          acf {
            demo_games_10 {
              alt_text
              title
              id
              acf {
                slide_url
                slide_title
                slide_description
              }
              localFile {
                childImageSharp {
                  fluid(maxWidth: 280) {
                    ...GatsbyImageSharpFluid_withWebp_noBase64
                  }
                }
              }
            }
          }
        }
      }
    }
    wordpressPage(id: { eq: $id }) {
      wordpress_id
      title
      content
      date(formatString: "MMMM DD, YYYY")
      path
      yoast_meta {
        yoast_wpseo_title
        yoast_wpseo_metadesc
      }
      acf {
        page_template
      }
      featured_media {
        alt_text
        localFile {
          publicURL
          childImageSharp {
            fluid(maxWidth: 1400) {
              ...GatsbyImageSharpFluid_withWebp_noBase64
            }
          }
        }  
      } 
    }
  }
`;
